import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Paper,
} from '@mui/material';
import {GallopDataType, GallopItem} from '../../shared/types/gallopData.type';
import {t} from 'i18next';
import {formatDate} from '../../shared/utils/DateUtils';
import {compact, isEmpty} from 'lodash';
import palette from '../../theme/palette';
import {useAuth} from '../../hooks/useAuth';

function SplitsTable({data, allSameDate, showMetadata = false, isEmptyGroups = false}: {
    allSameDate: boolean,
    data?: GallopItem[],
    showMetadata?: boolean,
    isEmptyGroups?: boolean,
}) {
    const trainings = data || []


    const FINISH_LINE_KEYS = ["1f-0", "200-0"]

    const splitKeys: string[] = (() => {
        try {
            const training = trainings.find(training => !isEmpty(training?.splits));
            return training?.splits.map(split => split.title) || [];
        } catch (error) {
            console.error('could not get insight param: ', error);
            return [];
        }
    })();


    const getValue = (training: GallopItem, key: string) => {

        let foundSplit = training.splits.find(split => split.title === key)
        if (foundSplit) {
            return foundSplit?.time ?? '-'
        } else {
            return "-"
        }

    }

    const getBgColor = (training: GallopItem, key: string) => {

        let foundSplit = training.splits.find(split => split.title === key)
        if (foundSplit) {
            return foundSplit?.background_color || 'initial'
        } else {
            return "initial"
        }

    }
    const getFontColor = (training: GallopItem, key: string) => {

        let foundSplit = training.splits.find(split => split.title === key)
        if (foundSplit) {
            return foundSplit?.font_color || 'initial'
        } else {
            return "initial"
        }

    }
    const renderFl = (key: string) => {
        if (FINISH_LINE_KEYS.includes(key)) {
            return <span className='gallopFinish'></span>
        } else {
            return null
        }
    }

    return (
        <TableContainer
            component={Paper}
            sx={{
                border: '1px solid black',
            }}
        >
            <Table
                size="small"
                sx={{
                    width: '100%',
                    '& td, & th': {
                        fontSize: '12px',
                    },
                    '& th': {
                        lineHeight: '1.1',
                    }
                }}
            >
                <TableHead
                    sx={{
                        '& td, & th': {
                            borderBottom: 'none',
                            boxSizing: 'border-box',
                        },
                    }}
                >
                    <TableRow
                        sx={{
                            background: `linear-gradient(to right, ${palette.light.primary.darker}, ${palette.light.primary.main})`,
                            color: 'white',
                        }}
                    >
                        {
                            showMetadata &&
                            <TableCell align="center" sx={{color: 'white', fontWeight: 600}}>
                                {`${t('date')} - ${t('eap:table:headers:trackName')} - ${t('eap:table:headers:trackCondition')}`}
                            </TableCell>
                        }
                        <TableCell align="center" sx={{color: 'white', fontWeight: 600, whiteSpace: 'nowrap'}}>
                            {t('horse')}
                        </TableCell>
                        {splitKeys.map((key) => (
                            <TableCell key={key} align="center"
                                       sx={{color: 'white', position: 'relative', fontWeight: 600}}>
                                {key}

                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody
                    sx={{
                        width: '100%',
                        '& td, & th': {
                            padding: '3px !important',
                            boxSizing: 'border-box',

                        },

                    }}
                >
                    {trainings.map((training, idx) => (
                        <TableRow key={idx} className="listItemExam" sx={{ breakInside: 'avoid' }}>
                            {
                                showMetadata &&
                                <TableCell align="center">
                                    <Typography fontSize={'12px'} fontWeight={600}>
                                        {
                                            compact([
                                                formatDate(training.creation_date, allSameDate ? 'HH:mm' : 'DD/MM/YYYY'),
                                                training.track_name?.display_name,
                                                training.track_condition?.display_name]).join(' - ')
                                        }

                                    </Typography>
                                </TableCell>
                            }
                            <TableCell sx={{whiteSpace: 'nowrap'}} align="center">
                                <Typography fontSize={'12px'} whiteSpace={'nowrap'}>
                                    {training.horse?.name}
                                </Typography>
                            </TableCell>
                            {isEmptyGroups ? (
                                idx === 0 && (
                                    <TableCell
                                        align="center"
                                        colSpan={splitKeys.length}
                                        rowSpan={trainings.length}
                                    >
                                        <Typography fontSize={12} fontStyle={'italic'}>
                                            <p>{t('eap:table:addFlMessage')}</p>
                                        </Typography>
                                    </TableCell>
                                )
                            ) : (
                                splitKeys.map((key) => (
                                    <TableCell

                                        key={key}
                                        align="center"
                                        style={{
                                            position: 'relative',
                                            backgroundColor: getBgColor(training, key),
                                            color: getFontColor(training, key),
                                        }}
                                    >
                                        <Typography textAlign="center" fontSize={'12px'}>
                                            {getValue(training, key)}
                                        </Typography>
                                        {renderFl(key)}
                                    </TableCell>
                                ))
                            )}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default SplitsTable;
